(() => {
  if (customElements.get("related-blog-products")) return;

  const GENERIC_TAGS = new Set([
    "airexhaustandturbo",
    "accessories",
    "chevy",
    "cummins",
    "diesel",
    "dieselengine",
    "dieselengines",
    "dieselemissions",
    "dieselexhaust",
    "dieselfueleconomy",
    "dieselparts",
    "dodge",
    "duramax",
    "ecodiesel",
    "ford",
    "forddiesel",
    "fueleconomy",
    "gmc",
    "performance",
    "performanceandlongevity",
    "powerstroke",
    "ram",
    "suspension",
    "truck",
  ]);

  const PRIMARY_TITLE_PRODUCT_RULES = [
    {
      phrase: "battery",
      excludedPhrases: ["battery cable", "hold down", "heat shield", "tray", "bracket"],
    },
    {
      phrase: "fuel additive",
      requiredPhrases: ["fuel additive", "diesel treatment", "cetane", "anti gel", "lubricity"],
    },
    {
      phrase: "exhaust",
      excludedPhrases: ["sensor", "turbocharger"],
    },
  ];

  const VEHICLE_CONTEXT_RULES = [
    {
      name: "first-gen-cummins",
      pattern: /\b(?:1st|first)\s+gen(?:eration)?\s+cummins\b|\b(?:1989|89)\s+(?:to\s+)?(?:1993|93)\s+(?:dodge\s+|ram\s+)?(?:5\s*9l?\s+)?cummins\b/,
      range: { start: 1989, end: 1993 },
      queries: ["1989 1993 cummins", "89 93 dodge cummins"],
    },
  ];

  const ARTICLE_TOPIC_QUERY_RULES = [
    { pattern: /\b(?:ve\s+pump|bosch\s+ve)\b/, phrase: "ve pump" },
    { pattern: /\b(?:kdp|killer\s+dowel\s+pin)\b/, phrase: "kdp repair kit" },
    { pattern: /\blift\s+pump\b/, phrase: "lift pump" },
    { pattern: /\binjectors?\b/, phrase: "injectors" },
    { pattern: /\bexhaust\b/, phrase: "exhaust" },
    { pattern: /\b(?:steering|track\s+bar|tie\s+rod)\b/, phrase: "steering" },
    { pattern: /\bsuspension\b/, phrase: "suspension" },
  ];

  const ARTICLE_PRODUCT_TYPE_FALLBACK_RULES = [
    { pattern: /\b(?:allison\s+)?transmissions?\b|\btorque\s+converters?\b|\bclutch\s+packs?\b/, phrases: ["transmission", "allison transmission"] },
    { pattern: /\bturbos?\b|\bturbochargers?\b|\bboost\b/, phrases: ["turbo", "turbocharger"] },
    { pattern: /\binjectors?\b|\binjection\b/, phrases: ["injectors"] },
    { pattern: /\blift\s+pumps?\b|\bfuel\s+pressure\b/, phrases: ["lift pump"] },
    { pattern: /\bfuel\s+filters?\b|\bfiltration\b|\bfuel\s+systems?\b|\bfuel\s+lines?\b/, phrases: ["fuel filter", "fuel system"] },
    { pattern: /\boil\s+coolers?\b|\bcooling\s+systems?\b|\bheat\s+cycles?\b/, phrases: ["oil cooler", "cooling system"] },
    { pattern: /\bhead\s+gaskets?\b|\bcylinders?\b|\bcompression\b/, phrases: ["head gasket", "engine parts"] },
    { pattern: /\begr\b|\bemissions?\b|\bcarbon\s+buildup\b/, phrases: ["egr", "emissions"] },
    { pattern: /\bexhaust\b|\bexhaust\s+gas\s+temperatures?\b|\begt\b/, phrases: ["exhaust"] },
    { pattern: /\bair\s+filters?\b|\bair\s+filtration\b|\bintakes?\b/, phrases: ["air filter", "intake"] },
  ];

  const CONTEXTUAL_PRODUCT_EXCLUSION_RULES = [
    {
      productPhrases: ["tps", "throttle position sensor"],
      articlePhrases: ["tps", "throttle position sensor"],
    },
    {
      productPhrases: ["map sensor", "cam crank position sensor", "crank position sensor"],
      articlePhrases: ["map sensor", "cam sensor", "crank position sensor"],
    },
  ];

  const STOP_WORDS = new Set([
    "a",
    "about",
    "after",
    "all",
    "also",
    "an",
    "and",
    "are",
    "as",
    "at",
    "be",
    "because",
    "best",
    "blog",
    "buying",
    "by",
    "can",
    "common",
    "difference",
    "differences",
    "durability",
    "does",
    "do",
    "explained",
    "failed",
    "failing",
    "failure",
    "failures",
    "for",
    "from",
    "guide",
    "have",
    "how",
    "if",
    "in",
    "into",
    "is",
    "it",
    "its",
    "issue",
    "issues",
    "jumpstart",
    "jumpstarting",
    "key",
    "louder",
    "look",
    "make",
    "many",
    "my",
    "need",
    "of",
    "on",
    "or",
    "our",
    "owner",
    "owners",
    "parts",
    "picks",
    "problem",
    "problems",
    "recurring",
    "replacement",
    "security",
    "should",
    "sound",
    "symptom",
    "symptoms",
    "that",
    "the",
    "their",
    "this",
    "tips",
    "to",
    "top",
    "upgrades",
    "use",
    "versus",
    "vs",
    "when",
    "with",
    "what",
    "why",
    "you",
    "your",
  ]);

  const WEAK_TOKENS = new Set([
    "1500",
    "2500",
    "3500",
    "4500",
    "5500",
    "60",
    "66",
    "67",
    "73",
    "chevy",
    "cummins",
    "diesel",
    "dodge",
    "duramax",
    "engine",
    "ecodiesel",
    "ford",
    "gladiator",
    "gmc",
    "jeep",
    "powerstroke",
    "ram",
    "truck",
  ]);

  class RelatedBlogProducts extends HTMLElement {
    connectedCallback() {
      this.limit = Number(this.dataset.limit) || 5;
      this.url = this.dataset.url;
      this.container = this.querySelector(".jsContainer");
      this.resultContainer = this.querySelector(".jsResultContainer");

      if (!this.container || !this.resultContainer) return;

      setTimeout(() => this.loadProducts(), 0);
    }

    getTags() {
      const tagScript = this.querySelector("[data-related-product-tags]");
      if (!tagScript?.textContent) return [];

      try {
        const tags = JSON.parse(tagScript.textContent);
        return Array.isArray(tags)
          ? tags.map((tag) => String(tag).trim()).filter(Boolean)
          : [];
      } catch {
        return [];
      }
    }

    getTagQuery(tag) {
      return `tag:"${String(tag).replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`;
    }

    normalizeTagValue(tag) {
      return String(tag || "").trim().toLowerCase();
    }

    getPrioritizedTags() {
      return [...this.tags].sort((a, b) => {
        const aGeneric = this.isGenericTag(a);
        const bGeneric = this.isGenericTag(b);

        if (aGeneric !== bGeneric) return aGeneric ? 1 : -1;
        return 0;
      });
    }

    isGenericTag(tag) {
      const rawTag = String(tag || "");
      const normalizedTag = rawTag.toLowerCase().replace(/[^a-z0-9]/g, "");

      return (
        rawTag.startsWith("#") ||
        rawTag.includes(",") ||
        GENERIC_TAGS.has(normalizedTag) ||
        normalizedTag.endsWith("performance") ||
        normalizedTag.endsWith("engine") ||
        normalizedTag.endsWith("engines") ||
        normalizedTag.endsWith("truck")
      );
    }

    async loadProducts() {
      if (this.loading) return;
      this.loading = true;

      try {
        // Liquid renders explicit selections immediately, in the saved metafield order.
        // They bypass all matching rules and can never be displaced by another source.
        let products = this.appendUniqueProducts([], Array.from(this.resultContainer.children)
          .slice(0, Number(this.dataset.metafieldCount) || 0));
        if (products.length >= this.limit) {
          this.loadSlider();
          return;
        }

        if (!this.url) return;
        this.tags = this.getTags();
        this.articleContext = this.getArticleContext();
        this.vehicleContext = this.getVehicleContext();
        this.searchPhrases = this.getSearchPhrases();
        this.fetchCache = new Map();

        const candidates = new Map();
        const queries = this.getProductQueries();
        const tagQueries = queries.filter((query) => query.source === "tag");
        const automaticQueries = queries.filter((query) => query.source !== "tag");
        // Only fetch automatic recommendations when selections and tag matches leave gaps.
        for (const group of [tagQueries, automaticQueries]) {
          if (products.length >= this.limit) break;
          const queryResults = await Promise.all(group.map((query) =>
            query.source === "tag" ? this.fetchTagProducts(query.phrase) : this.fetchProducts(query.value)
          ));
          queryResults.forEach((matches, index) => this.addCandidateProducts(candidates, matches, group[index]));
          products = this.appendUniqueProducts(products, this.rankProducts(candidates));
        }
        if (products.length < this.limit) products = this.appendUniqueProducts(products, await this.getTopicFallbackProducts());
        if (products.length < this.limit) products = this.appendUniqueProducts(products, await this.getDefaultFallbackProducts());
        if (!products.length) return;

        this.resultContainer.replaceChildren(...products.slice(0, this.limit));
        this.container.hidden = false;
        this.loadSlider();
      } catch (error) {
        console.error("Related blog products failed to load:", error);
      }
    }

    getArticleContext() {
      const sectionBody = this.closest(".section-body") || document;
      const title = sectionBody.querySelector(".article-card-title")?.textContent || "";
      const content = sectionBody.querySelector(".article-content")?.textContent || "";

      return {
        title,
        content,
      };
    }

    getVehicleContext() {
      const articleText = this.normalizeText(`${this.articleContext.title} ${this.articleContext.content}`);

      return VEHICLE_CONTEXT_RULES.find((rule) => rule.pattern.test(articleText)) || null;
    }

    getSearchPhrases() {
      const titlePhrases = this.extractPhrases(this.articleContext.title, {
        maxPhrases: 10,
        maxWords: 5,
        minWords: 1,
        source: "title",
      });
      const hasSpecificTitlePhrase = titlePhrases.some(({ value }) => this.getSignificantTokens(value).length >= 2);
      const bodyPhrases = this.extractPhrases(this.articleContext.content, {
        maxPhrases: hasSpecificTitlePhrase ? 4 : 8,
        maxWords: 4,
        minWords: 2,
        source: "body",
      });
      const seen = new Set();

      const phrases = this.removeCoveredSinglePhrases([...titlePhrases, ...bodyPhrases]);

      return phrases.filter((phrase) => {
        const key = phrase.value.toLowerCase();
        if (seen.has(key)) return false;
        seen.add(key);
        return true;
      });
    }

    extractPhrases(text, { maxPhrases, maxWords, minWords, source }) {
      const scores = new Map();

      const segments = String(text || "").split(/[.!?;:,()[\]|-]+/);
      for (const segment of segments) {
        const tokens = this.normalizeText(segment).split(" ").filter(Boolean);

        for (let start = 0; start < tokens.length; start++) {
          for (let size = minWords; size <= maxWords && start + size <= tokens.length; size++) {
            const words = tokens.slice(start, start + size);
            const phrase = this.cleanPhrase(words);
            if (!this.isUsefulPhrase(phrase, source)) continue;

            const value = phrase.join(" ");
            const score = this.scorePhrase(phrase, source);
            scores.set(value, { value, score: Math.max(scores.get(value)?.score || 0, score), source });

            const singular = phrase.map((word) => this.singularizeWord(word)).join(" ");
            if (singular !== value) {
              scores.set(singular, {
                value: singular,
                score: Math.max(scores.get(singular)?.score || 0, score - 1),
                source,
              });
            }
          }
        }
      }

      return [...scores.values()]
        .sort((a, b) => {
          if (b.score !== a.score) return b.score - a.score;
          return this.getSignificantTokens(b.value).length - this.getSignificantTokens(a.value).length;
        })
        .slice(0, maxPhrases);
    }

    cleanPhrase(words) {
      const phrase = [...words].filter((word) => !/^\d+$/.test(word));

      while (phrase.length && STOP_WORDS.has(phrase[0])) phrase.shift();
      while (phrase.length && STOP_WORDS.has(phrase[phrase.length - 1])) phrase.pop();

      return phrase;
    }

    isUsefulPhrase(words, source) {
      if (!words.length) return false;
      if (words.some((word) => STOP_WORDS.has(word))) return false;

      const significantTokens = this.getSignificantTokens(words.join(" "));
      if (!significantTokens.length) return false;
      if (words.length === 1) {
        return source === "title" && (this.isSpecificToken(words[0]) || words[0].length >= 4);
      }

      return significantTokens.length >= 1 || words.some((word) => this.isSpecificToken(word));
    }

    scorePhrase(words, source) {
      const significantTokens = this.getSignificantTokens(words.join(" "));
      const specificBonus = words.some((word) => this.isSpecificToken(word)) ? 24 : 0;
      const compactSpecificBonus = words.length <= 2 && words.some((word) => this.isSpecificToken(word)) ? 18 : 0;
      const weakPenalty = significantTokens.length < words.length ? 4 : 0;
      const lengthScore = this.getPhraseLengthScore(significantTokens.length);
      const sourceScore = source === "title" ? 90 : 22;

      return sourceScore + lengthScore + specificBonus + compactSpecificBonus - weakPenalty;
    }

    getPhraseLengthScore(length) {
      if (length <= 1) return 6;
      if (length === 2) return 20;
      if (length === 3) return 28;
      if (length === 4) return 34;
      return 8;
    }

    isSpecificToken(word) {
      return /[a-z]+\d|\d+[a-z]/.test(word);
    }

    removeCoveredSinglePhrases(phrases) {
      const multiTokenPhrases = phrases.filter(({ value }) => this.getSignificantTokens(value).length > 1);

      return phrases.filter(({ value }) => {
        const tokens = this.getSignificantTokens(value);
        if (tokens.length !== 1) return true;

        return !multiTokenPhrases.some((phrase) => this.getSignificantTokens(phrase.value).includes(tokens[0]));
      });
    }

    getProductQueries() {
      const queries = [];
      const seen = new Set();
      const addQuery = (value, score, source, phrase = "") => {
        const normalizedValue = String(value || "").trim();
        const key = `${source}:${normalizedValue.toLowerCase()}`;
        if (!normalizedValue || seen.has(key)) return;

        seen.add(key);
        queries.push({ value: normalizedValue, score, source, phrase: phrase || normalizedValue });
      };

      this.getPrioritizedTags()
        .filter((tag) => !this.isGenericTag(tag))
        .slice(0, 5)
        .forEach((tag, index) => {
          addQuery(this.getTagQuery(tag), 10000 - index * 500, "tag", tag);
        });

      this.getVehicleSearchPhrases().forEach((value, index) => {
        addQuery(value, 9000 - index * 150, "vehicle", value);
      });

      this.searchPhrases.forEach(({ value, score, source }) => {
        addQuery(value, score, source, value);
      });

      if (!this.searchPhrases.length) {
        this.getPrioritizedTags().slice(0, 3).forEach((tag, index) => {
          if (!this.isGenericTag(tag)) return;
          addQuery(tag, 10 - index, "generic-tag", tag);
        });
      }

      return queries.slice(0, 14);
    }

    async getTopicFallbackProducts() {
      const queries = this.getTopicFallbackQueries();
      if (!queries.length) return [];

      const candidates = new Map();
      const queryResults = await Promise.all(queries.map((query) => this.fetchProducts(query.value)));

      queryResults.forEach((products, index) => {
        this.addCandidateProducts(candidates, products, queries[index]);
      });

      return this.rankTopicFallbackProducts(candidates);
    }

    getTopicFallbackQueries() {
      const articleText = this.normalizeText(`${this.articleContext.title} ${this.articleContext.content}`);
      const vehiclePhrase = this.getFallbackVehiclePhrase(articleText);
      const queries = [];
      const seen = new Set();

      const addQuery = (phrase, score) => {
        const value = vehiclePhrase ? `${vehiclePhrase} ${phrase}` : phrase;
        const key = value.toLowerCase();
        if (seen.has(key)) return;

        seen.add(key);
        queries.push({ value, score, source: "topic-fallback", phrase });
      };

      ARTICLE_PRODUCT_TYPE_FALLBACK_RULES.forEach(({ pattern, phrases }, ruleIndex) => {
        if (!pattern.test(articleText)) return;

        phrases.forEach((phrase, phraseIndex) => {
          addQuery(phrase, 600 - ruleIndex * 20 - phraseIndex * 5);
        });
      });

      return queries.slice(0, 8);
    }

    getFallbackVehiclePhrase(articleText) {
      if (/\bduramax\b|\b6\s*6\b|\blly\b|\blbz\b|\blmm\b|\blml\b|\bl5p\b/.test(articleText)) return "duramax";
      if (/\bcummins\b|\b5\s*9\b|\b6\s*7\b/.test(articleText)) return "cummins";
      if (/\bpowerstroke\b|\bpower\s+stroke\b|\b7\s*3\b|\b6\s*0\b|\b6\s*4\b|\b6\s*7\b/.test(articleText)) return "powerstroke";
      if (/\becodiesel\b|\beco\s+diesel\b/.test(articleText)) return "ecodiesel";

      return "";
    }

    rankTopicFallbackProducts(candidates) {
      return [...candidates.values()]
        .map((candidate) => ({
          ...candidate,
          ...this.scoreProduct(candidate),
        }))
        .filter(({ product, phraseMatchScore, vehicleMatched }) => {
          if (this.isProductExcluded(product)) return false;
          return vehicleMatched || phraseMatchScore >= 55;
        })
        .sort((a, b) => {
          if (b.score !== a.score) return b.score - a.score;
          return a.order - b.order;
        })
        .map(({ product }) => product);
    }

    async getDefaultFallbackProducts() {
      const fallbackQuery = String(this.dataset.fallbackQuery || "*").trim();
      if (!fallbackQuery) return [];

      return (await this.fetchProducts(fallbackQuery)).filter((product) => !this.isProductExcluded(product));
    }

    appendUniqueProducts(products, additions) {
      const result = [...products];
      const seen = new Set(result.map((product) => this.getProductKey(product)));
      for (const product of additions) {
        if (result.length >= this.limit) break;
        const key = this.getProductKey(product);
        if (!key || seen.has(key)) continue;
        seen.add(key);
        result.push(product);
      }
      return result;
    }

    getVehicleSearchPhrases() {
      if (!this.vehicleContext) return [];

      const phrases = [...this.vehicleContext.queries];
      const yearPhrase = this.getVehicleYearPhrase();
      const articleText = this.normalizeText(`${this.articleContext.title} ${this.articleContext.content}`);

      ARTICLE_TOPIC_QUERY_RULES.forEach(({ pattern, phrase }) => {
        if (!pattern.test(articleText)) return;
        phrases.push(yearPhrase ? `${phrase} ${yearPhrase} cummins` : `${phrase} cummins`);
      });

      return phrases;
    }

    getVehicleYearPhrase() {
      if (!this.vehicleContext?.range) return "";

      const { start, end } = this.vehicleContext.range;
      return `${String(start).slice(-2)} ${String(end).slice(-2)}`;
    }

    async fetchTagProducts(tag) {
      // Search can find only some products carrying a newly added tag.
      // Fetch both sources concurrently; either can succeed without the other.
      const requests = [this.fetchProducts(this.getTagQuery(tag))];
      try {
        const urls = JSON.parse(this.querySelector("[data-related-product-tag-urls]")?.textContent || "[]");
        const url = urls.find((entry) => this.normalizeTagValue(entry.tag) === this.normalizeTagValue(tag))?.url;
        if (url) requests.push(this.fetchProductUrl(url));
      } catch {
        // Missing or malformed optional collection markup must not disable tag search.
      }
      const results = await Promise.allSettled(requests);
      return results.flatMap((result) => result.status === "fulfilled" ? result.value : []);
    }

    async fetchProducts(query) {
      if (this.fetchCache.has(query)) return this.fetchCache.get(query);

      // A failed optional lookup must not discard selections or other successful matches.
      const request = this.fetchProductQuery(query).catch(() => []);
      this.fetchCache.set(query, request);
      return request;
    }

    async fetchProductQuery(query) {
      const separator = this.url.includes("?") ? "&" : "?";
      return this.fetchProductUrl(`${this.url}${separator}q=${encodeURIComponent(query)}`);
    }

    async fetchProductUrl(url) {
      const response = await fetch(url);
      if (!response.ok) return [];

      const html = await response.text();
      const resultsHtml = html.split("<!-- split -->")[1];
      if (!resultsHtml) return [];

      const template = document.createElement("template");
      template.innerHTML = resultsHtml.trim();

      return [...template.content.children];
    }

    addCandidateProducts(candidates, products, query) {
      for (const product of products) {
        if (query.source === "tag" && !this.productHasTag(product, query.phrase)) continue;

        const productKey = this.getProductKey(product);
        if (!productKey) continue;

        const existing = candidates.get(productKey);
        if (existing) {
          existing.sourceScore = Math.max(existing.sourceScore, query.score);
          existing.sources.push(query);
          existing.tagged = existing.tagged || query.source === "tag";
          continue;
        }

        candidates.set(productKey, {
          product,
          sourceScore: query.score,
          sources: [query],
          tagged: query.source === "tag",
          order: candidates.size,
        });
      }
    }

    rankProducts(candidates) {
      const candidateList = [...candidates.values()];

      return candidateList
        .map((candidate) => ({
          ...candidate,
          ...this.scoreProduct(candidate),
        }))
        .filter(({ product, tagged, phraseMatchScore, primaryTitleMatchScore, requiredSpecificTokenMatched, vehicleMatched }) => {
          if (this.isProductExcluded(product)) return false;
          if (tagged) return true;
          if (vehicleMatched) return true;
          if (this.hasStrongTitlePhrases()) return primaryTitleMatchScore >= 90 && requiredSpecificTokenMatched;
          return phraseMatchScore >= 90;
        })
        .sort((a, b) => {
          const tagPriority = Number(b.tagged) - Number(a.tagged);
          if (tagPriority) return tagPriority;
          if (b.score !== a.score) return b.score - a.score;
          return a.order - b.order;
        })
        .map(({ product }) => product);
    }

    scoreProduct(candidate) {
      const title = this.normalizeText(candidate.product.querySelector(".product-name")?.textContent || candidate.product.textContent || "");
      const productType = this.normalizeText(candidate.product.dataset.productType || "");
      let score = candidate.sourceScore;
      let phraseMatchScore = 0;
      let primaryTitleMatchScore = 0;

      if (candidate.tagged) score += 5000;

      const vehicleMatched = this.matchesVehicleContext(`${productType} ${title}`);
      if (vehicleMatched) score += 4000;

      for (const source of candidate.sources) {
        if (source.source === "tag") continue;
        if (source.source === "vehicle") continue;
        const matchScore = this.scoreProductMatch(productType, title, source.phrase);
        phraseMatchScore = Math.max(phraseMatchScore, matchScore);
        score += matchScore;
      }

      const primaryTitlePhrase = this.getPrimaryTitlePhrase();
      if (primaryTitlePhrase) {
        primaryTitleMatchScore = Math.max(primaryTitleMatchScore, this.scoreProductMatch(productType, title, primaryTitlePhrase.value));
      }

      const requiredSpecificTokenMatched = this.matchesRequiredSpecificToken(productType, title);
      if (requiredSpecificTokenMatched) score += 120;

      return { score, phraseMatchScore, primaryTitleMatchScore, requiredSpecificTokenMatched, vehicleMatched };
    }

    getProductTags(product) {
      try {
        const tags = JSON.parse(product.dataset.productTags || "[]");
        return Array.isArray(tags) ? tags : [];
      } catch {
        return [];
      }
    }

    productHasTag(product, tag) {
      const normalizedTag = this.normalizeTagValue(tag);
      if (!normalizedTag) return false;

      return this.getProductTags(product).some((productTag) => this.normalizeTagValue(productTag) === normalizedTag);
    }

    hasStrongTitlePhrases() {
      return Boolean(this.getPrimaryTitlePhrase());
    }

    getPrimaryTitlePhrase() {
      return this.searchPhrases.find((phrase) => phrase.source === "title" && phrase.score >= 90);
    }

    getRequiredSpecificTokens() {
      const primaryTitlePhrase = this.getPrimaryTitlePhrase();
      if (!primaryTitlePhrase) return [];

      return this.getSignificantTokens(primaryTitlePhrase.value).filter((token) => this.isSpecificToken(token));
    }

    matchesRequiredSpecificToken(productType, productTitle) {
      const requiredTokens = this.getRequiredSpecificTokens();
      if (!requiredTokens.length) return true;
      if (this.matchesVehicleContext(`${productType} ${productTitle}`)) return true;

      const productTokens = new Set([...this.getSignificantTokens(productType), ...this.getSignificantTokens(productTitle)]);
      return requiredTokens.some((token) => productTokens.has(token));
    }

    isProductExcluded(product) {
      const productTitle = this.normalizeText(product.querySelector(".product-name")?.textContent || product.textContent || "");
      if (this.isProductExcludedByArticleContext(productTitle)) return true;

      const primaryTitlePhrase = this.getPrimaryTitlePhrase();
      if (!primaryTitlePhrase) return false;

      const rule = PRIMARY_TITLE_PRODUCT_RULES.find(({ phrase }) => this.hasPhrase(primaryTitlePhrase.value, phrase));
      if (!rule) return false;

      if (rule.excludedPhrases?.some((phrase) => this.hasPhrase(productTitle, phrase))) return true;
      if (rule.requiredPhrases && !rule.requiredPhrases.some((phrase) => this.hasPhrase(productTitle, phrase))) return true;

      return false;
    }

    isProductExcludedByArticleContext(productTitle) {
      const articleText = this.normalizeText(`${this.articleContext.title} ${this.articleContext.content}`);

      return CONTEXTUAL_PRODUCT_EXCLUSION_RULES.some(({ productPhrases, articlePhrases }) => {
        if (!productPhrases.some((phrase) => this.hasPhrase(productTitle, phrase))) return false;
        return !articlePhrases.some((phrase) => this.hasPhrase(articleText, phrase));
      });
    }

    scoreProductMatch(productType, productTitle, phrase) {
      const phraseTokens = this.getSignificantTokens(phrase);
      if (!phraseTokens.length) return 0;

      let score = 0;
      if (this.matchesProductType(productType, phrase)) score += 170;
      if (this.hasPhrase(productTitle, phrase)) score += 85;

      const titleTokens = new Set(this.getSignificantTokens(productTitle));
      const typeTokens = new Set(this.getSignificantTokens(productType));
      const titleMatches = phraseTokens.filter((token) => titleTokens.has(token)).length;
      const typeMatches = phraseTokens.filter((token) => typeTokens.has(token)).length;
      const fullTitleMatch = titleMatches === phraseTokens.length;
      const fullTypeMatch = typeMatches === phraseTokens.length;

      if (fullTypeMatch) score += 120;
      if (fullTitleMatch) score += 70;
      score += typeMatches * 22 + titleMatches * 12;

      for (const token of phraseTokens) {
        if (this.isSpecificToken(token) && (titleTokens.has(token) || typeTokens.has(token))) score += 45;
      }

      return score;
    }

    matchesProductType(productType, query) {
      if (!productType || !query) return false;
      const typeTokens = this.getSignificantTokens(productType);
      const queryTokens = this.getSignificantTokens(query);
      if (!typeTokens.length || !queryTokens.length) return false;

      const typeSet = new Set(typeTokens);
      const matchedTokens = queryTokens.filter((token) => typeSet.has(token));
      if (this.hasPhrase(productType, query) || this.hasPhrase(query, productType)) return true;

      return matchedTokens.length === queryTokens.length;
    }

    getProductKey(product) {
      const link = product.querySelector('a[href*="/products/"]');
      if (!link) return "";

      try {
        const path = new URL(link.getAttribute("href"), window.location.origin).pathname;
        return path.match(/\/products\/[^/]+/)?.[0] || path;
      } catch {
        return link.getAttribute("href").split("?")[0];
      }
    }

    matchesVehicleContext(text) {
      if (!this.vehicleContext?.range) return false;

      return this.hasYearRangeCovering(text, this.vehicleContext.range);
    }

    hasYearRangeCovering(text, range) {
      const normalizedText = this.normalizeText(text);
      const matches = normalizedText.matchAll(/\b(\d{2,4})\s+(\d{2,4})\b/g);

      for (const match of matches) {
        const start = this.normalizeYear(match[1]);
        const end = this.normalizeYear(match[2]);
        if (!start || !end) continue;
        if (start <= range.start && end >= range.end) return true;
      }

      return false;
    }

    normalizeYear(value) {
      const number = Number(value);
      if (!Number.isInteger(number)) return 0;
      if (number >= 1000) return number;
      if (number < 10) return 0;
      return number >= 80 ? 1900 + number : 2000 + number;
    }

    normalizeText(value) {
      return String(value || "")
        .toLowerCase()
        .replace(/&/g, " and ")
        .replace(/[^a-z0-9]+/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    }

    hasPhrase(text, phrase) {
      return this.countPhrase(text, phrase) > 0;
    }

    countPhrase(text, phrase) {
      const normalizedPhrase = this.normalizeText(phrase);
      if (!text || !normalizedPhrase) return 0;

      const escapedPhrase = normalizedPhrase.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
      return text.match(new RegExp(`(^|\\s)${escapedPhrase}(?=\\s|$)`, "g"))?.length || 0;
    }

    getSignificantTokens(value) {
      return this.normalizeText(value)
        .split(" ")
        .map((word) => this.singularizeWord(word))
        .filter((word) => word.length > 2 && !STOP_WORDS.has(word) && !WEAK_TOKENS.has(word));
    }

    singularizeWord(word) {
      return String(word || "").replace(/ies$/, "y").replace(/s$/, "");
    }

    loadSlider() {
      const slider = this.resultContainer.closest(".slider-component");
      if (!slider) return;
      // If still a lazy-script, let its eventual slider-component connection initialize.
      slider.classList.remove("jsSliderDelay");
      if (typeof slider.load === "function") slider.load();
    }
  }

  customElements.define("related-blog-products", RelatedBlogProducts);
})();
